import { LineChart } from "@mui/x-charts";
import { xLabels } from "../utils/UrlHandle";

const IncomeExpenseChart = ({
  listIncomeOnly,
  listExpenseOnly,
  listProfit,
}) => {
  return (
    <LineChart
      height={350}
      margin={{ top: 30, right: 30, bottom: 70, left: 70 }} // Add padding
      series={[
        {
          data: listIncomeOnly,
          label: "Income(LKR)",
          valueFormatter: (value) =>
            Number(value).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            }),
          showMark: true,
        },
        {
          data: listExpenseOnly,
          label: "Expenses(LKR)",
          color: `#e2726e`,
          valueFormatter: (value) =>
            Number(value).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            }),
          showMark: true,
        },
        {
          data: listProfit,
          label: "Profit(LKR)",
          color: "#0288d1",
          valueFormatter: (value) =>
            Number(value).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            }),
          showMark: true,
        },
      ]}
      xAxis={[{ scaleType: "point", data: xLabels }]}
    />
  );
};

export default IncomeExpenseChart;
